import React, { memo } from "react";
import {
  Bar,
  BarChart,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { formatAvgDaysLate } from "../../utils/dashboardUtils";

const ON_TIME_FILL = "#bbf7d0";
const LATE_FILL = "#fecaca";
const BAR_SIZE = 33;
const BAR_RADIUS = 5;
const BAR_LABEL_FONT_SIZE = 12;

const TatPersonBar = memo(({ row, onPersonClick }) => {
  const total = row.onTime + row.late;
  const chartData = [row];
  const onTimeRadius = row.late === 0
    ? [BAR_RADIUS, BAR_RADIUS, BAR_RADIUS, BAR_RADIUS]
    : [BAR_RADIUS, 0, 0, BAR_RADIUS];
  const lateRadius = row.onTime === 0
    ? [BAR_RADIUS, BAR_RADIUS, BAR_RADIUS, BAR_RADIUS]
    : [0, BAR_RADIUS, BAR_RADIUS, 0];

  return (
    <div className="tat-person-row">
      <div className="tat-person-name-cell">
        <button
          type="button"
          className="dashboard-person-link"
          onClick={() => onPersonClick?.(row)}
        >
          {row.person}
        </button>
      </div>
      <div className="tat-person-bar-cell">
        <ResponsiveContainer width="100%" height={BAR_SIZE}>
          <BarChart
            layout="vertical"
            data={chartData}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          >
            <XAxis type="number" domain={[0, total]} hide />
            <YAxis
              type="category"
              dataKey="person"
              width={0}
              tick={false}
              axisLine={false}
              tickLine={false}
            />
            <Bar
              dataKey="onTime"
              stackId="tat"
              fill={ON_TIME_FILL}
              radius={onTimeRadius}
              barSize={BAR_SIZE}
              isAnimationActive={false}
            >
              {row.onTime > 0 && (
                <LabelList
                  dataKey="onTime"
                  position="center"
                  fill="#166534"
                  fontSize={BAR_LABEL_FONT_SIZE}
                  fontWeight={600}
                  formatter={(value) => `${value} on time`}
                />
              )}
            </Bar>
            <Bar
              dataKey="late"
              stackId="tat"
              fill={LATE_FILL}
              radius={lateRadius}
              barSize={BAR_SIZE}
              isAnimationActive={false}
            >
              {row.late > 0 && (
                <LabelList
                  dataKey="late"
                  position="center"
                  fill="#991b1b"
                  fontSize={BAR_LABEL_FONT_SIZE}
                  fontWeight={600}
                  formatter={(value) => `${value} late`}
                />
              )}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="tat-person-pct-cell">{row.onTimePct}%</div>
      <div className="tat-person-avg-cell">{formatAvgDaysLate(row.avgDaysLate)}</div>
    </div>
  );
});

TatPersonBar.displayName = "TatPersonBar";

const TatByPersonChart = ({ rows = [], onPersonClick }) => {
  if (!rows.length) {
    return <p className="dashboard-section-empty">No TAT data available.</p>;
  }

  return (
    <section className="dashboard-section">
      <h3 className="dashboard-section-title">
        TAT by Person — Tasks Closed Within Due Date
      </h3>
      <div className="tat-by-person-chart">
        {rows.map((row) => (
          <TatPersonBar key={row.id} row={row} onPersonClick={onPersonClick} />
        ))}
      </div>
    </section>
  );
};

export default memo(TatByPersonChart);
